import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as apiClient from "../../common/apiClient";
import {
  Container, ButtonContainer, SelectedButton, UnselectedButton, SearchContainer, Box, Select, Search, SearchImage, SearchInput, SearchBox, ListBox, ListBoxTitle, ListBoxRow, CarBox, CarIcon, CarDetailBox, CarDetailBoxLabel, CarDetailBoxItem, CarDetailBoxValue, BoxGraphContainer, GraphContainer, GraphHeading, Graph, CarDetailGraphBox, ListBox1, CarDetailStatusBox, ScanIcon, CarHealthIcon, Score, Scored, TotalScore, EmptyBox, NoActiveScanContainer, NoActiveScanText, StyledNotification, OuterCircleWrapper, InnerSpinner
} from './styled';

import Search_Icon from '../../assets/searchicon.svg';
import Car_ICON from '../../assets/ToyotaLandCruiser2022.png';
import Car_Health_Bad from '../../assets/carhealthbad.svg';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import ReportViewer from '../ui/reportViewer/reportviewer';
import ReportLogViewer from '../ui/reportlogs/reportlogviewer';
import * as App_Constant from "../../common/constants";
import {

  Spinner,
  SpinnerSize,

} from '../../components';
export const AllScan = () => {
  const [formFields, setFormFields] = useState({ emailId: '', password: '' })
  const [searchText, setSearchText] = useState<any>(null)
  const [selectedButton, setSelectedButton] = useState<any>('Active')
  const [sortDirection, setSortDirection] = useState<any>('desc')
  const [loadingReportId, setLoadingReportId] = useState<any>('')
  const [requestId, setRequestId] = useState<any>(null)
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<any>(false);
  const [totalActiveScan, setTotalActiveScan] = useState(0);
  const [isLoadingActiveScan, setIsLoadingActiveScan] = useState(false);
  const [reportFiles, setReportFiles] = useState<any>([]);
  const [totalCompletedScan, setTotalCompletedScan] = useState(0);
  const [isLoadingCompletedScan, setIsLoadingCompletedScan] = useState(true);
  const [completedScan, setCompletedScan] = useState<any[]>([]);
  const [isOpenReport, setIsOpenReport] = useState<any>(false);
  const [isOpenLog, setIsOpenLog] = useState<any>(false);
  const [canStop, setCanStop] = useState<any>(false);
  
  const [activeScan, setActiveScan] = useState<any[]>([]);
  const [remainingSeconds, setRemainingSeconds] = useState(App_Constant.AUTO_REFRESH_INTERVAL); // Set your desired interval
  const [lastRefreshTime, setLastRefreshTime] = useState<any>(null);


  const handleClose = () => {
    setLoadingReportId(null);
    setIsOpenReport(false);
    setIsOpenLog(false);
  }
  const handleClick = (type: any) => {
    if (type == "Active") {
      setSearchText("");
      loadActiveScan(sortDirection, null);
    }
    else {
      setSearchText("");
      loadCompletedScan(sortDirection, null);
    }
    setSelectedButton(type);
  }

  useEffect(() => {
    loadActiveScan('desc', null);
  }, []);
  const loadActiveScan = (sort_Direction: any, search_text: any) => {
    //setActiveScan([]);
    // setIsLoadingActiveScan(true);
    if (search_text == null || search_text == undefined || search_text == "") {
      search_text = "-"
    }
    apiClient.get(`requests/getactiveRequestDetail/${localStorage.getItem("business_partner_id")}/1000000/${sort_Direction}/${search_text}`, null).then((response: any) => {
      if (response) {
        setActiveScan(response.activeScan);
        setTotalActiveScan(parseInt(response.totalActiveScan));
      }
      //setIsLoadingActiveScan(false);
    }).catch((err) => {
      //setIsLoadingActiveScan(false);
    })
  };
  useEffect(() => {
    const refreshInterval = setInterval(() => {
      // Call the API to refresh activeScan
      loadActiveScan(sortDirection, searchText);
      // loadActiveFLW();
      setLastRefreshTime(new Date()); // Update last refresh time
      setRemainingSeconds(App_Constant.AUTO_REFRESH_INTERVAL); // Reset remaining seconds
    }, App_Constant.AUTO_REFRESH_INTERVAL * 1000);

    // Clear interval on component unmount
    return () => clearInterval(refreshInterval);
  }, []); // Removed [remainingSeconds]

  // Update remaining seconds and last refresh time every second
  useEffect(() => {
    const countdownInterval = setInterval(() => {
      if (remainingSeconds > 0) {
        setRemainingSeconds((prev) => prev - 1);
      } else {
        setLastRefreshTime(new Date());
        setRemainingSeconds(App_Constant.AUTO_REFRESH_INTERVAL);
      }
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(countdownInterval);
  }, [remainingSeconds]);

  const DownloadReport = (request_id: any) => {
    setLoadingReportId(request_id);
    apiClient.get(`request-reports?filter[offset]=0&filter[limit]=100&filter[order]=id%20ASC&filter[where][requestId]=${request_id}`, null).then((response: any) => {
      if (response) {
        setIsOpenReport(true);
        setReportFiles(response);
        
      }
      setLoadingReportId(null);
    }).catch((err) => {
      setLoadingReportId(null);
    })
  };
  
  const LogsReport = (request_id: any,hideStopButton:any) => { 
    setLoadingReportId(request_id);
    setIsOpenLog(true);
    setCanStop(hideStopButton);
  };
  
  const calculateLastRefreshTime = (lastRefreshTime: any) => {
    if (!lastRefreshTime) return 'Unknown';
    let now = new Date();
    const secondsDiff = Math.floor((now.getTime() - lastRefreshTime.getTime()) / 1000);
    return secondsDiff;
  };
  const loadCompletedScan = (sort_Direction: any, search_text: any) => {
    setCompletedScan([]);
    setIsLoadingCompletedScan(true);
    if (search_text == null || search_text == undefined || search_text == "") {
      search_text = "-"
    }
    apiClient.get(`requests/getcompletedRequestDetail/${localStorage.getItem("business_partner_id")}/1000000/${sort_Direction}/${search_text}`, null).then((response: any) => {
      if (response) {
        setCompletedScan(response.completedScan);
        setTotalActiveScan(parseInt(response.totalCompletedScan));
      }
      setIsLoadingCompletedScan(false);
    }).catch((err) => {
      setIsLoadingCompletedScan(false);
    })
  };
  return (
    <Container>

      <ButtonContainer>
        {selectedButton == 'Active' ?
          <SelectedButton onClick={() => handleClick("Active")} >
            Active Scan
          </SelectedButton> :
          <UnselectedButton onClick={() => handleClick("Active")} >
            Active Scan
          </UnselectedButton>
        }
        {selectedButton == 'Historical' ?
          <SelectedButton onClick={() => handleClick("Historical")} >
            Historical Scans
          </SelectedButton> :
          <UnselectedButton onClick={() => handleClick("Historical")} >
            Historical Scans
          </UnselectedButton>

        }

      </ButtonContainer>
      <SearchContainer>
        <Box>
          <div style={{ paddingTop: 10 }} >
            Sort by:
          </div>
          <div>
            <Select value={sortDirection} onChange={(event) => {
              setSortDirection(event.target.value);
              if (selectedButton == 'Active') {
                loadActiveScan(event.target.value, searchText)
              }
              else {
                loadCompletedScan(event.target.value, searchText)
              }


            }} >
              <option value={"desc"} >By Latest</option>
              <option value={"asc"}>By Oldest</option>
            </Select>

          </div>
          <div>
            <SearchBox>
              <Search>
                <SearchImage src={Search_Icon} />
                <SearchInput type={"text"} placeholder='Search' value={searchText}
                  onChange={(event) => {
                    setSearchText(event.target.value);
                    if (selectedButton == 'Active') {
                      loadActiveScan(sortDirection, event.target.value)
                    }
                    else {
                      loadCompletedScan(sortDirection, event.target.value)
                    }


                  }}
                />
              </Search>
            </SearchBox>
          </div>
        </Box>
      </SearchContainer>
      {selectedButton == 'Active' && !isLoadingActiveScan && activeScan.length == 0 ? <NoActiveScanContainer>
        <NoActiveScanText>
          No active scans found.
        </NoActiveScanText>
      </NoActiveScanContainer> : null}

      {selectedButton != 'Active' && !isLoadingCompletedScan && completedScan.length == 0 ? <NoActiveScanContainer>
        <NoActiveScanText>
          No historical scans found.
        </NoActiveScanText>
      </NoActiveScanContainer> : null}

      {selectedButton == 'Active' && (

        <StyledNotification>
          Auto-refreshing in {remainingSeconds} secs. Last refreshed {calculateLastRefreshTime(lastRefreshTime)} seconds ago.
        </StyledNotification>

      )}

      {selectedButton == 'Active' && isLoadingActiveScan ? <EmptyBox> <Spinner size={SpinnerSize.SMALL} /></EmptyBox> : null}
      {selectedButton != 'Active' && isLoadingCompletedScan ? <EmptyBox> <Spinner size={SpinnerSize.SMALL} /></EmptyBox> : null}
      {selectedButton == 'Active' && !isLoadingActiveScan ?
        <>
          {activeScan.map((item: any, index: any) => {
            return <ListBox>
              <ListBoxTitle>
                {item.car_name}
              </ListBoxTitle>
              <ListBoxRow>
                <CarBox  >
                  <CarIcon src={item.img_url ? item.img_url : App_Constant.NO_CAR} />
                </CarBox>
                <CarDetailBox>
                  <CarDetailBoxItem>
                    <CarDetailBoxLabel>
                      VIN
                    </CarDetailBoxLabel>
                    <CarDetailBoxValue>
                      {item.vin_no}
                    </CarDetailBoxValue>
                  </CarDetailBoxItem>
                  <CarDetailBoxItem>
                    <CarDetailBoxLabel>
                      Scan Start :
                    </CarDetailBoxLabel>
                    <CarDetailBoxValue>
                      {apiClient.formatDate(item.start_scan_date)}
                    </CarDetailBoxValue>
                  </CarDetailBoxItem>
                  <CarDetailBoxItem>
                    <CarDetailBoxLabel>
                      FLW
                    </CarDetailBoxLabel>
                    <CarDetailBoxValue>
                      {item.user_name}
                    </CarDetailBoxValue>
                  </CarDetailBoxItem>

                </CarDetailBox>
                <CarDetailBox>
                  <CarDetailBoxItem>
                    <CarDetailBoxLabel>
                      Last Scan :

                    </CarDetailBoxLabel>
                    <CarDetailBoxValue>
                      {apiClient.formatDate(item.last_scan_date)}
                    </CarDetailBoxValue>
                  </CarDetailBoxItem>
                  <CarDetailBoxItem>
                    <CarDetailBoxLabel>
                      Car Owner :
                    </CarDetailBoxLabel>
                    <CarDetailBoxValue>
                      {item.customer_first_name} {" "} {item.customer_last_name}
                    </CarDetailBoxValue>
                  </CarDetailBoxItem>
                  <CarDetailBoxItem>
                    <CarDetailBoxLabel>
                      Status :
                    </CarDetailBoxLabel>
                    <CarDetailBoxValue>
                      {item.step_name != null ? item.step_name : 'NA'}
                    </CarDetailBoxValue>
                  </CarDetailBoxItem>
                  <CarDetailBoxItem>
                  <CarDetailBoxLabel>
                    Logs :
                  </CarDetailBoxLabel>
                  <CarDetailBoxValue>
                    {loadingReportId == item.request_id ? "Please Wait.." : <a onClick={() => LogsReport(item.request_id,true)} href='#'>{"View Logs"}</a>}
                  </CarDetailBoxValue>
                </CarDetailBoxItem>
                </CarDetailBox>
                <CarDetailGraphBox  >
                  <GraphContainer>
                    <Graph>
                      {/* <CircularProgressbar background={false} counterClockwise={true} value={item.step_value != null ? parseFloat(item.step_value) : 0}
                        strokeWidth={11}
                        text={`${item.step_value} %`}
                        styles={buildStyles({
                          rotation: 0.25,
                          strokeLinecap: 'butt',
                          textSize: '22px',
                          pathTransitionDuration: 0.5,
                          pathColor: `#FBBC05`,
                          textColor: '#000',
                          trailColor: ' #00000000',
                        })}
                     /> 
    */}
                      <OuterCircleWrapper>
                        <CircularProgressbar
                          value={item.step_value}
                          strokeWidth={11}
                          text={`${item.step_value != null? item.step_value:0}%`}
                          styles={buildStyles({
                            rotation: 0,
                            strokeLinecap: 'butt',
                            textSize: '16px',
                            pathTransitionDuration: 0.5,
                            pathColor: `#FBBC05`,
                            textColor: '#000',
                            trailColor: ' #00000000',
                          })}
                        />
                        <InnerSpinner />
                      </OuterCircleWrapper>


                    </Graph>
                  </GraphContainer>
                </CarDetailGraphBox>


              </ListBoxRow>

            </ListBox>
          })}


        </> : null}
      {selectedButton != 'Active' && !isLoadingCompletedScan ? <>
        {completedScan.map((item: any, index: any) => {
          return <ListBox1>

            <ListBoxRow>
              <CarBox  >
                <CarIcon src={item.img_url ? item.img_url : Car_ICON} /> 
              </CarBox>
              <CarDetailBox>
                <CarDetailBoxItem>
                  <CarDetailBoxLabel>
                    Scan Id
                  </CarDetailBoxLabel>
                  <CarDetailBoxValue>
                    {item.request_id}
                  </CarDetailBoxValue>
                </CarDetailBoxItem>
                <CarDetailBoxItem>
                  <CarDetailBoxLabel>
                    Car :
                  </CarDetailBoxLabel>
                  <CarDetailBoxValue>
                    {item.car_name}
                  </CarDetailBoxValue>
                </CarDetailBoxItem>
                <CarDetailBoxItem>
                  <CarDetailBoxLabel>
                    FLW
                  </CarDetailBoxLabel>
                  <CarDetailBoxValue>
                    {item.user_name}
                  </CarDetailBoxValue>
                </CarDetailBoxItem>
              </CarDetailBox>
              <CarDetailBox>
                <CarDetailBoxItem>
                  <CarDetailBoxLabel>
                    Scan Date :

                  </CarDetailBoxLabel>
                  <CarDetailBoxValue>
                    {apiClient.formatDate(item.start_scan_date)}
                  </CarDetailBoxValue>
                </CarDetailBoxItem>
                <CarDetailBoxItem>
                  <CarDetailBoxLabel>
                    Report :
                  </CarDetailBoxLabel>
                  <CarDetailBoxValue>
                    {loadingReportId == item.request_id ? "Please Wait.." : <a onClick={() => DownloadReport(item.request_id)} href='#'>{"View Report"}</a>}
                  </CarDetailBoxValue>
                </CarDetailBoxItem>
                
                <CarDetailBoxItem>
                  <CarDetailBoxLabel>
                    Status :
                  </CarDetailBoxLabel>
                  <CarDetailBoxValue>
                    {item.vehicle_status != null ? item.vehicle_status : 'NA'}
                  </CarDetailBoxValue>
                </CarDetailBoxItem>
                <CarDetailBoxItem>
                  <CarDetailBoxLabel>
                    Logs :
                  </CarDetailBoxLabel>
                  <CarDetailBoxValue>
                    {loadingReportId == item.request_id ? "Please Wait.." : <a onClick={() => LogsReport(item.request_id,false)} href='#'>{"View Logs"}</a>}
                  </CarDetailBoxValue>
                </CarDetailBoxItem>
              </CarDetailBox>
              <CarDetailStatusBox  >
                <ScanIcon>
                  <CarHealthIcon src={Car_Health_Bad} />

                </ScanIcon>
                <Score>
                  <Scored>{item.score != null ? item.score : 'NA'}</Scored>
                  {" / "}
                  <TotalScore>{item.total_score != null ? item.total_score : 'NA'}</TotalScore>
                </Score>
              </CarDetailStatusBox>


            </ListBoxRow>

          </ListBox1>

        })}

      </> : null}
      <EmptyBox />
      {isOpenReport  && <ReportViewer  close={handleClose} files={reportFiles} />}
      {isOpenLog  && loadingReportId!='' && <ReportLogViewer canStop={canStop} request_id={loadingReportId} close={handleClose} />}



    </Container>
  );
};
